import { getMarketRegions, getIsoCountries, getMultipleCodeList } from '@/api/common'
import i18n from '@/locales'
import _ from 'lodash'

export default {
  state: {
    marketRegions: [], // 推广市场
    isoCountries: [], // 国家地区
    areaCodeList: [], // 区号
    multipleCodeList: [], // code table
    // 證件類型
    identityType: [{
      value: 1,
      label: i18n.t('myKKpartners.profile.field.identityTypeOptions.passport')
    }, {
      value: 2,
      label: i18n.t('myKKpartners.profile.field.identityTypeOptions.twIdentityCard')
    }, {
      value: 3,
      label: i18n.t('myKKpartners.profile.field.identityTypeOptions.other')
    }]
  },
  mutations: {},
  actions: {
    getMarketRegions({ state }) {
      getMarketRegions().then(res => {
        if (localStorage.getItem('extraChannel') === 'MANAGE') {
          const marketRegionData = _.map(res.data || [], function(item) {
            if (item.country_cd === 'KK') {
              item.local_name = i18n.t('affiliateCid.selector.allRegion')
            }
            return item
          })
          state.marketRegions = marketRegionData || []
        } else {
          state.marketRegions = res.data || []
        }
      })
    },
    getIsoCountries({ state }) {
      getIsoCountries().then(res => {
        state.isoCountries = res.data || []
        const codeList = []
        res.data.map(item => {
          codeList.push(item.tel_area)
        })
        state.areaCodeList = Array.from(new Set(codeList)).sort()
      })
    },
    getMultipleCodeList({ state }) {
      getMultipleCodeList({
        code_type : 'AFFI_WEB_CAT'
      }).then(res => {
        state.multipleCodeList = res.data || []
      })
    }
  }
}
